module.exports = __webpack_public_path__ + "media/images/filled-star-sm-solid-3605e069.svg";